import React from "react";
import SensorBase from "./SensorBase";

const FIELD = "deltaT";
const UNIT = "°C";

const DeltaT: React.FC = () => {
  return (
    <SensorBase field={FIELD} unit={UNIT}></SensorBase>
  );
};

export default DeltaT;
